// Bridge from the business API layer to the shell for the Accountant HQ
// requirement (PRD 40 §5.5.1, revised): parseEnvelope reports every 403
// `firm_required` response here, and LiveBusinessShell subscribes to send the
// practitioner to activation.
//
// The same shape as the read-only and period-lock notifiers, for the same
// reason: the API layer knows the answer and has no way to navigate, and the
// shell can navigate and has no way to know.
//
// Throttled because a screen opens several business calls at once and every
// one of them will come back refused — one navigation, not six.

type Listener = () => void;

const THROTTLE_MS = 5000;

let listeners = new Set<Listener>();
let lastNotifiedAt = 0;

/** Subscribe to firm-required refusals; returns the unsubscribe function. */
export function subscribeFirmRequired(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Called by the API layer on a 403 firm_required response. */
export function notifyFirmRequired(): void {
  const now = Date.now();
  if (now - lastNotifiedAt < THROTTLE_MS) return;
  lastNotifiedAt = now;
  listeners.forEach(listener => listener());
}

/** Test hook — clears listeners and the throttle window. */
export function resetFirmRequiredNotifier(): void {
  listeners = new Set();
  lastNotifiedAt = 0;
}
